<template>
    <div
        class="flex-grow"
        :class="{ 'relative' : ! isFieldView }"
    >
        <div class="p-lg border-b border-neutral-lightest">
            <div class="flex justify-start text-md py-xs">
                <span class="headline-sm font-bold">Team {{ team.name }}</span>
            </div>
        </div>
        <ul class="list-reset text-sm h-full pb-4xl">
            <div v-if="sellers.length > 0" class="pb-4xl mb-4xl">
                <seller-list-item
                    v-for="seller in sellers"
                    :key="'seller_list_item' + seller.id"
                    :seller="seller"
                    :selected-seller="selectedSeller"
                    :selected-addresses="selectedAddresses"
                />
            </div>
        </ul>

        <div v-if="sellers.length === 0" class="p-lg">
            Inga säljare finns i det angivna teamet, det går därför inte att tilldela adresser för tillfället.
        </div>

        <div
            class="p-lg text-center fixed pin-b w-1/2 bg-white"
            :class="{ 'pin-l flex w-full flex-row-reverse bg-neutral-lightest' : isFieldView }"
        >
            <button
                class="btn btn-lg is-primary w-full block text-center text-white"
                :class="{ 'mx-xl' : isFieldView }"
                :disabled="! hasAddressesAndSeller"
                @click="assignAddresses"
            >
                Tilldela
            </button>
            <button
                class="btn btn-lg is-ghost w-full text-center block p-0 md:py-sm leading-normal"
                :class="{ 'mt-lg' : ! isFieldView, 'mx-xl' : isFieldView }"
                @click="goBack"
            >
                Till projektöversikten
            </button>
        </div>
    </div>
</template>

<script>
    import SellerListItem from './SellerListItem';

    export default {
        components: { SellerListItem },
        props: {
            project: {
                type: Object,
                required: true,
            },
            team: {
                type: Object,
                required: true,
            },
            sellers: {
                type: [Array, Object],
                required: true,
            },
            selectedAddresses: {
                type: [Array, Object],
                required: true,
            },
            selectedSeller: {
                type: Object,
                default: null,
            },
            isFieldView: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            hasAddressesAndSeller() {
                return this.selectedAddresses.length > 0 && this.selectedSeller;
            },
        },

        methods: {
            assignAddresses() {
                if (this.selectedAddresses.length > 0 && this.selectedSeller) {
                    EventBus.$emit('assign-addresses');
                }
            },

            goBack() {
                let backRoute = route('admin.sales-projects.show', this.project);
                if (this.isFieldView) {
                    backRoute = route('field.sales.sales-projects.index');
                }

                window.location.href = backRoute;
            },
        },
    };
</script>
